const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Whey Protein",
    productBrand: "Max Titanium",
    description: "900g",
    priceWithoutDiscount: "150.00",
    quantity: "11",
    imageSrc: require("../../assets/ImgProducts/Whey/whey_900g_max_titanium.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Whey Protein",
    productBrand: "Integral medica",
    description: "900g Refil",
    priceWithoutDiscount: "100.00",
    quantity: "1",
    imageSrc: require("../../assets/ImgProducts/Whey/whey_integralmedica_907g-refil.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Creatina",
    productBrand: "Max Titanium",
    description: "100g",
    priceWithoutDiscount: "90.00$",
    quantity: "2",
    imageSrc: require("../../assets/ImgProducts/Creatine/creatine_100g_max_titanium.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino Égide",
    productBrand: "Max titanium",
    description: "150g",
    priceWithoutDiscount: "100.00",
    quantity: "6",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_egide_max_titanium_150g.png"),
  },
];

export default ProducsData;
